import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { toast } from "sonner";
import { submitLead, track } from "../../lib/api";

export const LeadCaptureDialog = ({ open, onOpenChange, page }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (!name || !email) {
      toast.error("Please enter your name and email");
      return;
    }
    setSending(true);
    try {
      await submitLead({
        lead_type: "b2c_fallback",
        name,
        email,
        phone,
        message: "Requested help completing a flight booking",
        source_page: page,
      });
      track("lead_capture", page);
      toast.success("Thanks! Our team will reach out with the best fare.");
      onOpenChange(false);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const cls = "w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#970C10]/30";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="lead-capture-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Need help finding the best fare?</DialogTitle>
          <DialogDescription>
            Leave your details and our booking team will send you the lowest available price — usually within minutes.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 pt-2">
          <input data-testid="lead-name-input" className={cls} placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} />
          <input data-testid="lead-email-input" className={cls} placeholder="Email address" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="lead-phone-input" className={cls} placeholder="WhatsApp / phone (optional)" value={phone} onChange={(e) => setPhone(e.target.value)} />
          <button
            data-testid="lead-submit-btn"
            onClick={submit}
            disabled={sending}
            className="w-full bg-[#970C10] hover:bg-[#7A0A0D] text-white font-bold py-3 rounded-full transition-colors duration-200 disabled:opacity-50"
          >
            {sending ? "Sending..." : "Get My Best Fare"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
